module.exports = __webpack_public_path__ + "static/media/inbank.253d21bd.svg";